<template>
    <div class="card h-100">
        <div class="card-body">
            <div class="card-title">
                <h4>{{ name }}</h4>
            </div>
            <div class="d-flex flex-wrap">
                <div class="form-group col-12">
                    <div class="d-flex flex-wrap justify-content-end">
                        <button
                            class="btn btn-success"
                            :disabled="savingInProcess"
                            @click="save"
                        >
                            {{ savingInProcess ? 'Working...' : 'Save' }}
                        </button>
                    </div>
                </div>
                <div
                    v-for="setting in settings"
                    :key="setting.key"
                    class="form-group col-12"
                >
                    <label>{{ setting.title }}</label>
                    <component
                        :is="`${getType(setting.type)}-input`"
                        v-model="setting.value"
                        :setting-key="setting.key"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import startCase from 'lodash/startCase';
import { mapActions } from 'vuex';
import BoolInput from '@/components/settings/inputs/Bool';
import IntegerInput from '@/components/settings/inputs/Integer';
import SelectInput from '@/components/settings/inputs/Select';
import StringInput from '@/components/settings/inputs/String';

export default {
    components: {
        BoolInput,
        IntegerInput,
        SelectInput,
        StringInput
    },

    props: {
        tag: {
            type: Array,
            required: true,
            default: () => []
        }
    },

    data() {
        return {
            settings: {},
            name: '',
            savingInProcess: false
        };
    },

    created() {
        this.name = startCase(this.tag[0].tag);
        this.settings = [...this.tag].sort((a, b) => a.order - b.order);
    },

    methods: {
        ...mapActions({
            updateSettingsByTags: 'settings/update'
        }),

        async save() {
            this.savingInProcess = true;

            try {
                await this.updateSettingsByTags({
                    tag: this.name.toLowerCase(),
                    settings: this.settings
                });

                let successMessage = this.name + ' settings have been updated!';

                this.$toaster(successMessage);
            } catch (err) {
                console.error(err);

                this.$toasterError();
            }

            this.savingInProcess = false;
        },

        getType(type) {
            if (['int', 'integer'].includes(type)) {
                return 'integer';
            }

            if (['bool', 'boolean'].includes(type)) {
                return 'bool';
            }

            return type;
        }
    }
};
</script>
